<template>
  <v-toolbar-items
    :style="titleBarStyles"
    class="headline text-uppercase pl-0 pr-sm-10"
  >
    <img
      v-if="!showDropdown"
      :width="logoWidth"
      justify="center"
      class="m-auto"
      :class="
        $vuetify.breakpoint.smAndDown ? 'responsive-logo' : marginClass
      "
      :src="currentLogo"
    />
    <v-menu v-if="showDropdown" offset-y :nudge-width="10" v-model="productSwitcherIcon">
      <template v-slot:activator="{ on }">
        <v-btn text x-large v-on="on">
          <img
            :width="logoWidth"
            justify="center"
            class="m-auto"
            :class="
              $vuetify.breakpoint.smAndDown ? 'responsive-logo' : marginClass
            "
            :src="currentLogo"
          />
          <span class="drop-down-arrow">
            <v-icon v-if="!productSwitcherIcon" color="#616161" class="pl-2">
              mdi-menu-down
            </v-icon>
            <v-icon v-if="productSwitcherIcon" color="#616161" class="pl-2">
              mdi-menu-up
            </v-icon>
          </span>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(ele, index) in items"
          :key="index"
          @click="onAppChange(ele)"
        >
          <v-list-item-content class="py-0">
            <v-list-item-title class="h2 font-weight-medium border-bottom">
              <v-img
                :width="ele.width"
                justify="center"
                class="m-auto"
                :class="$vuetify.breakpoint.smAndDown ? 'responsive-logo' : ''"
                :src="ele.logo"
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>
<script>
import { mapGetters } from "vuex";
import { setCurrentAppCookie } from "@core/plugins/cookie.js";
export default {
  name: "MAppsDropdown",
  data() {
    return {
      show: false,
      productSwitcherIcon: false,
      logoWidth: 200,
      marginClass: "",
      titleBarStyles: {
        width: this.$vuetify.breakpoint.name === "sm" ? "100%" : null,
        marginLeft: this.$vuetify.breakpoint.name === "sm" ? "0px" : null,
      },
      apps: [
        {
          id: "commerce",
          name: "Commerce Cloud",
          path: `/commerce`,
          include: process.env.VUE_APP_PRODUCT != "Commerce" && (window.location.host.includes('staging.maropost.com') || window.location.port == '8080'),
          subpath: "/dashboard",
          width: 200,
          logo: require('@core/assets/images/logo-commerce.svg'),
        },
        {
          id: "marketing",
          name: "Marketing Cloud",
          path: `/accounts`,
          subpath: "/dashboard",
          include: process.env.VUE_APP_PRODUCT != "Marketing",
          width: 180,
          logo: require('@core/assets/images/logo-marketing.svg'),
        },
        {
          id: "service",
          name: "Service Cloud",
          path: `/service`,
          subpath: "/dashboard",
          include: process.env.VUE_APP_PRODUCT != "Service",
          width: 180,
          logo: require('@core/assets/images/logo-service.svg'),
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      account: "auth/account",
      roles: "auth/roles",
      userAccess: "auth/userAccess"
    }),
     showDropdown(){
      if(this.account.current){
        /**
         * Handled Settings Platform apps dropdownd
         */
         if (process.env.VUE_APP_PRODUCT === 'Settings') {
          if (
            !this.account.current.enable_marketing ||
            !this.userAccess.haveMarketingRole
          ) {
            this.apps[1].include = false
          } else {
            this.apps[1].include = true
          }
          if (
            !this.account.current.enable_service ||
            !this.userAccess.haveServiceRole
          ) {
            this.apps[2].include = false
          } else {
            this.apps[2].include = true
          }
          return true
        }
        if((this.account.current.enable_marketing && this.userAccess.haveMarketingRole && 
            this.account.current.enable_service && this.userAccess.haveServiceRole)){
        return true;
        } else {
          return false;
        }
     }
    },
    items() {
      return this.apps.filter(i=>i.include);
    },
    currentLogo() {
      this.marginClass = "mt-2";
      const appBase = window.location.pathname.split('/')[1]
      if (appBase === "service") {
        this.logoWidth = 195;
        return require("@core/assets/images/logo-service.svg");
      } else if (appBase === "commerce") {
        this.logoWidth = 210;
        this.marginClass = "";
        return require("@core/assets/images/logo-commerce.svg");
      } else if (appBase === "settings") {
        this.logoWidth = 195;
        this.marginClass = "";
        return require("@core/assets/images/logo-settings.svg");
      } else {
        this.logoWidth = 195;
        return require("@core/assets/images/logo-marketing.svg");
      }
    },
  },
  mounted(){
    if(window.location.origin.includes('beta.maropost.com')){
      this.apps.push({
          id: "commerce",
          name: "Commerce Cloud",
          path: `/commerce`,
          subpath: "/dashboard",
          logo: "/unified/static/images/logo-commerce.svg",
        })
    }
  },
  methods: {
    onAppChange({ id, ...ele }) {
      setCurrentAppCookie(id, 1);
      window.location.href = `${ele.path}/${this.account.id}${ele.subpath}`;
    },
  },
};
</script>
